import Head from "next/head";

interface CustomHeadProps {
  title?: string;
  description?: string;
  keywords?: string[];
  image?: string;
  canonical?: string;
  icon?: string;
}

function CustomHead(props: CustomHeadProps) {
  return (
    <Head>
      <title>{props.title}</title>
      <meta name="description" content={props.description} />
      <meta name="keywords" content={props.keywords?.join(",")} />
      <meta name="image" content={props.image} />
      <link rel="canonical" href={props.canonical} />
      <link
        rel="icon"
        type="image/svg+xml"
        href={`${props.icon ?? "/favicon.svg"}`}
      />
      <link
        rel="icon"
        type="image/png"
        href={`${props.icon ?? "/favicon.png"}`}
      />
    </Head>
  );
}
export default CustomHead;
